import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { FormPersonaNaturalDto } from '../../../../forms/dto/form-persona-natural.dto';
import { FormPersonaJuridicaDto } from '../../../../forms/dto/form-persona-juridica.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurarCuentasService } from '../../../../configuracion-cuenta/services/configurar-cuentas.service';
import { PersonaDto } from '../../../../../dto/tramites/persona.dto';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';
import { TableColumn } from '../../../../../dto/util/table-column';
import { TableAction } from '../../../../../dto/util/table-action';
import { FormField } from '../../../../../dto/util/form-field';
import { DireccionPersonaResponseDto } from '../../../../../dto/tramites/direccion-persona.dto';
import { PersonaLoginDTO } from '../../../../../dto/util/persona.dto';
import { TranslateService } from '@ngx-translate/core';
import { PaisDto } from '../../../../../dto/expediente/pais.dto';
import { ListasService } from '../../../../../services/listas.service';
import { TextTransformService } from '../../../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../../../util/modal-datos/services/datos-adicionales.service';
import { AnexoPrecargaResponseDto } from '../../../../../dto/anexo/anexo-tramite.dto';
import { TipoAnexoTipoTramiteDto } from '../../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { ArchivosFormDTO } from '../../../../../dto/expediente/archivos-form.dto';
import { Constants } from "../../../../../constants/constants";
import { ArchivoItemDto } from "../../../../util/archivos-tramite/dto/ArchivoItemDto";
import { ProteccionConsumidorService } from '../services/proteccion-consumidor.service';
import { FormComponent } from '../../../../util/form/form.component';

@Component({
  selector: 'app-datos-demandante',
  templateUrl: './datos-demandante.component.html',
  styleUrl: './datos-demandante.component.scss',
})
export class DatosDemandanteComponent implements OnInit, OnChanges {
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  // archivoPrecargadoPoderJudicial?: AnexoPrecargaResponseDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Input() volver: boolean = false;
  @Output() demandanteEmit = new EventEmitter<{
    formTipoPersonaDemandante: FormGroup;
    formDemandante: FormGroup;
  }>();
  @Output() apoderadoEmit = new EventEmitter<{
    formApoderado: FormGroup;
  }>();
  mostrarFormulario = true;
  tipoPersona?: number;
  tipoDocumento?: number = 0;
  dataUsuario!: PersonaLoginDTO;
  demandantes: PersonaDto[] = [];
  demandados: PersonaDto[] = [];
  apoderado: PersonaDto = {};
  formTipoPersona!: FormGroup;
  formDemandante!: FormGroup;
  formApoderado!: FormGroup;
  formMediosTec!: FormGroup;
  formTieneApoderado!: FormGroup;

  columnsNatural: TableColumn[] = [];
  columnsJuridica: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableNatural: PersonaDto[] = [];
  dataTableJuridic: PersonaDto[] = [];

  paises: PaisDto[] = [];

  entidadId: number = Constants.ID_ENTIDAD_SIC;

  private prevTipo: number | null = null;
  private prevIdentificacion: string | null = null;

  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  formFieldsTipoPersona: FormField[] = [];

  formFieldsDemandanteNatural: FormField[] = [];

  formFieldsDemandanteJuridic: FormField[] = [];

  formFieldsMedios: FormField[] = [];

  formFieldsTieneApoderado: FormField[] = [];

  formFieldsApoderado: FormField[] = [];

  // seteo inputs otro Departamento y municipio
  auxIdCountryDemandante: number[] = [];

  indexEditarDemandante: number | undefined = undefined;

  tipoAnexoPoderJudicial!: TipoAnexoTipoTramiteDto;

  anexoPoderJudicial: ArchivosFormDTO | null = null;

  pesoTotalArchivosMB: string = '0.00';

  // Archivos
  archivosPrecargados: AnexoPrecargaResponseDto[] = [];
  idsFilesPasoUno: TipoAnexoTipoTramiteDto[] = [];
  archivosCargadosPasoUno: ArchivoItemDto[] = [];
  // Boolean
  guardarArchivos = false;
  existePersona: boolean = false;
  mensajeErrorDemandante: string = '';
  validarAbogado: boolean = false;
  mostrarArchivos: boolean = false;
  buildFormsDemandante() {
    this.formFieldsTipoPersona = [
      {
        name: 'tipoPersona',
        label: this.comunText['tipo-demandante'],
        type: 'select',
        required: true,
        options: [
          { Id: '1', Nombre: this.comunText['persona-natural-select'] },
          { Id: '2', Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];

    this.formFieldsDemandanteNatural = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        personTypeId: '1',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(4),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'firstName',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'secondName',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'firstLastName',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'secondLastName',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        visible: true,
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'phone',
        label: this.proconText['tramite-sic-procon']['telefono'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength:
            this.proconText['tramite-sic-procon']['telefono-minlength'],
          maxlength:
            this.proconText['tramite-sic-procon']['telefono-maxlength'],
          pattern: this.proconText['tramite-sic-procon']['telefono-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        value: 1,
        disabled: true,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamentoDemandante',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandante',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-municipio'],
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];

    this.formFieldsDemandanteJuridic = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '2',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.maxLength(9)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.proconText['tramite-sic-procon']['nit-maxlength'],
          pattern:
            this.proconText['tramite-sic-procon']['identificacion-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'address',
        label: this.comunText['direccion'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'phone',
        label: this.proconText['tramite-sic-procon']['telefono'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength:
            this.proconText['tramite-sic-procon']['telefono-minlength'],
          maxlength:
            this.proconText['tramite-sic-procon']['telefono-maxlength'],
          pattern: this.proconText['tramite-sic-procon']['telefono-pattern'],
        },
      },
      // {
      //   name: 'country',
      //   label: this.comunText['country'],
      //   type: 'select',
      //   required: true,
      //   options: [],
      //   width: '6',
      //   visible: false,
      //   value: 1,
      //   errorMessages: { required: this.comunText['country-required'] },
      // },
      // {
      //   name: 'departament',
      //   label: this.comunText['departament'],
      //   type: 'select',
      //   required: true,
      //   options: [],
      //   width: '6',
      //   visible: true,
      //   errorMessages: { required: this.comunText['departament-required'] },
      // },
      // {
      //   name: 'municipality',
      //   label: this.comunText['municipality'],
      //   type: 'select',
      //   required: true,
      //   options: [],
      //   width: '6',
      //   visible: true,
      //   errorMessages: { required: this.comunText['municipality-required'] },
      // },
      // {
      //   name: 'otroDepartamentoDemandante',
      //   label: this.comunText['departament'],
      //   placeholder: '',
      //   type: 'text',
      //   required: true,
      //   width: '6',
      //   validation: [
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      //     Validators.maxLength(30)
      //   ],
      //   errorMessages: {
      //     required: this.comunText['departament-required'],
      //     maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
      //     pattern: this.comunText['department-pattern']
      //   },
      //   dependsOn: 'country',
      //   visibilityCondition: value => {
      //     // Busca el país Colombia en la lista
      //     const paisColombia = this.paises.find(
      //       item => item.Codigo === Constants.CODIGO_COLOMBIA
      //     );
      //     // Si value es undefined, no mostrar el campo
      //     if (value === undefined || value === null) {
      //       return false;
      //     }
      //     // Mostrar el campo si el valor no corresponde al Id de Colombia
      //     return paisColombia ? value !== paisColombia.Id : true;
      //   },
      //   tooltip: this.proconText['tramite-sic-procon']['escriba-departamento'],
      // },
      // {
      //   name: 'otroMunicipioDemandante',
      //   label: this.comunText['municipality'],
      //   placeholder: '',
      //   type: 'text',
      //   required: true,
      //   width: '6',
      //   validation: [
      //     Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
      //     Validators.maxLength(30)
      //   ],
      //   errorMessages: {
      //     required: this.proconText['tramite-sic-procon']['campo-required'],
      //     maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
      //     pattern: this.comunText['municipality-pattern']
      //   },
      //   dependsOn: 'country',
      //   visibilityCondition: value => {
      //     // Busca el país Colombia en la lista
      //     const paisColombia = this.paises.find(
      //       item => item.Codigo === Constants.CODIGO_COLOMBIA
      //     );
      //     // Si value es undefined, no mostrar el campo
      //     if (value === undefined || value === null) {
      //       return false;
      //     }
      //     // Mostrar el campo si el valor no corresponde al Id de Colombia
      //     return paisColombia ? value !== paisColombia.Id : true;
      //   },
      //   tooltip: this.proconText['tramite-sic-procon']['escriba-municipio'],
      // },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        isSubtitle: true,
        subtitleText: this.comunText['subtitulo-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'representativeFirstName',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'representativeSecondName',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'representativFirstLastName',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'representativeSecondLastName',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
    ];

    this.formFieldsMedios = [
      {
        name: 'medios',
        label: this.proconText['tramite-sic-procon']['medios'],
        type: 'select',
        required: true,
        placeholder: this.proconText['seleccione-opcion'],
        options: [
          { Id: 'S', Nombre: this.comunText['opcion-si'] },
          { Id: 'N', Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['seleccion-medios'],
        },
      },
    ];
  }

  buildFormsApoderado() {
    this.formFieldsTieneApoderado = [
      {
        name: 'attorney',
        label: this.comunText['utiliza-abogado'],
        type: 'select',
        required: true,
        placeholder: this.proconText['seleccione-opcion'],
        modalVisibility: true,
        titleModal: this.comunText['ver-mas'],
        sizeModal: 'xl',
        contentTypeModal: 'text',

        contentModalText:
          this.proconText['tramite-sic-procon']['text-modal-apoderado'],
        options: [
          { Id: 'S', Nombre: this.comunText['opcion-si'] },
          { Id: 'N', Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
      },
    ]

    this.formFieldsApoderado = [
      {
        isSubtitle: true,
        subtitleText: this.proconText['tramite-sic-procon']['datos-apoderado'],
        name: 'subTitle',
        label: this.proconText['tramite-sic-procon']['paso-siete'],
        type: 'text',
        visible: true,
      },
      {
        name: 'attorneyId',
        label: this.comunText['primer-nombre'],
        type: 'text',
        visible: false,
      },
      {
        name: 'attorneyFirstName',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'attorneySecondName',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'attorneyFirstLastName',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'attorneySecondLastName',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '3',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'attorneyNumberOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
          maxlength:
            this.proconText['tramite-sic-procon']['identificacion-maxlength'],
          pattern:
            this.proconText['tramite-sic-procon']['identificacion-pattern'],
        },
      },
      {
        name: 'attorneyProfessionalCard',
        label: this.comunText['tarjeta-profesional'],
        type: 'text',
        required: true,
        placeholder: this.comunText['tarjeta-profesional-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          minlength: this.comunText['tarjeta-profesional-minlength'],
          maxlength: this.comunText['tarjeta-profesional-maxlength'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
        },
      },
      {
        name: 'attorneyAddress',
        label: this.comunText['direccion-notificacion'],
        type: 'text',
        required: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'attorneyEmail',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }

  @ViewChildren(FormComponent) personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly fb: FormBuilder,
    private readonly configurarCuentaService: ConfigurarCuentasService,
    private readonly alertaModalService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly _cuentaService: ConfigurarCuentasService,
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
  }

  ngOnInit() {
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.formTipoPersona = this.fb.group({
      tipoPersona: [this.tipoPersona, Validators.required],
    });

    this.formDemandante = this.fb.group({
      firstName: ['', Validators.required],
      secondName: [''],
      firstLastName: [''],
      secondLastName: [''],
      typeOfDocument: [''],
      numberOfDocument: [''],
      email: [''],
      phone: [''],
      address: [''],
      municipality: [''],
    });

    this.formTieneApoderado = this.fb.group({
      attorney: ['', Validators.required],
    });

    this.formApoderado = this.fb.group({
      attorneyId: [''],
      attorneyFirstName: [''],
      attorneySecondName: [''],
      attorneyFirstLastName: [''],
      attorneySecondLastName: [''],
      typeOfDocument: [''],
      attorneyNumberOfDocument: [''],
      attorneyProfessionalCard: [''],
      attorneyAddress: [''],
      attorneyEmail: [''],
    });

    this.formMediosTec = this.fb.group({
      medios: ['', Validators.required],
    });
    setTimeout(() => {
      this.getListaDocumentosApoderado();
    }, 3000);

    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
      this.buildFormsDemandante();
      this.buildFormsApoderado();
      this.iniciarColumnas();
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
      this.buildFormsDemandante();
      this.buildFormsApoderado()
      this.iniciarColumnas();
    });
    sessionStorage.setItem(Constants.PASOS, '1');
    sessionStorage.setItem(Constants.ARCHIVOS_SIC_PROCON_PASO_UNO, 'false');
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic']?.currentValue;

    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      // segmento para que suba archivos asociados al id del tramite en proceso
      if (changes['tramiteSic'].currentValue?.id != undefined) {
        if (tramite.anexos && tramite.anexos.length > 0) {
          this.archivosPrecargados = tramite.anexos;
          this.formFieldsTieneApoderado = this.formFieldsTieneApoderado.map(field => {
            if (field.name === 'attorney') {
              field.value = Constants.VALOR_S;
            }
            return field;
          })
          this.formTieneApoderado.patchValue({
            attorney: Constants.VALOR_S,
          });
        }
      }

      if (tramite?.demandante !== undefined) {
        for (const demandante of tramite.demandante) {
          if (
            !this.demandantes.some(
              dem =>
                dem.idTipoIdentificacion === demandante.idTipoIdentificacion &&
                dem.identificacion === demandante.identificacion
            )
          ) {
            if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
              demandante.datosRepresentanteLegal = null;
            }
            this.demandantes.push(demandante);
          }
        }

        this.dataTableNatural = this.demandantes.filter(
          item => item.idTipoPersona === 1
        );
        this.dataTableJuridic = this.demandantes.filter(
          item => item.idTipoPersona === 2
        );

        this.iniciarColumnas();
        this.reiniciarFormularios();
      }

      this.formFieldsMedios = this.formFieldsMedios.map(field => {
        if (field.name === 'medios') {
          field.value = tramite.tieneAccesoMediosTecnologicos ? Constants.VALOR_S : Constants.VALOR_N;
        }
        return field;
      });

      this.formMediosTec.patchValue({
        medios: tramite.tieneAccesoMediosTecnologicos ? Constants.VALOR_S : Constants.VALOR_N,
      });

      if (this.archivosCargadosPasoUno.length > 0) {
        let paso = Number(sessionStorage.getItem(Constants.PASOS));

        this.guardarArchivos = true;
        if (paso < 2) {
          setTimeout(() => {
            this.consultarTramitePorID(tramite.id!);
          }, 4000);
        }
        this.formFieldsTieneApoderado = this.formFieldsTieneApoderado.map(field => {
          if (field.name === 'attorney') {
            field.value = tramite.tieneApoderado ? Constants.VALOR_S : this.archivosCargadosPasoUno.length > 0 ? Constants.VALOR_S : Constants.VALOR_N
          }
          return field;
        })
        this.formTieneApoderado.patchValue({
          attorney: tramite.tieneApoderado ? Constants.VALOR_S : this.archivosCargadosPasoUno.length > 0 ? Constants.VALOR_S : Constants.VALOR_N,
        });
      }
      if (tramite.apoderado?.id) {
        this.formFieldsApoderado = this.formFieldsApoderado.map(field => {
          if (tramite.apoderado?.id) {
            if (field.name === 'attorneyFirstName') {
              field.value = `${tramite.apoderado?.primerNombre}`;
            }
            if (field.name === 'attorneyId') {
              field.value = `${tramite.apoderado?.id}`;
            }
            if (field.name === 'attorneySecondName') {
              field.value = `${tramite.apoderado?.segundoNombre ?? ''}`;
            }
            if (field.name === 'attorneyFirstLastName') {
              field.value = `${tramite.apoderado?.primerApellido}`;
            }
            if (field.name === 'attorneySecondLastName') {
              field.value = `${tramite.apoderado?.segundoApellido ?? ''}`;
            }
            // this.getListaDocumentosApoderado();
            if (field.name === 'typeOfDocument') {
              field.value = Number(`${tramite.apoderado?.idTipoIdentificacion}`);
            }
            if (field.name === 'attorneyNumberOfDocument') {
              field.value = tramite.apoderado?.identificacion ?? '';
            }
            if (field.name === 'attorneyProfessionalCard') {
              field.value = tramite.apoderado?.tarjetaProfesional ?? undefined;
            }
            if (field.name === 'attorneyAddress') {
              field.value = tramite.apoderado?.direccionPersona?.[0]?.direccionNotificacion ?? undefined;
            }
            if (field.name === 'attorneyEmail') {
              field.value = tramite.apoderado?.correoElectronico ?? undefined;
            }
          }
          return field;
        });

        this.formApoderado.patchValue({
          attorneyFirstName: tramite.apoderado?.primerNombre,
          attorneySecondName: tramite.apoderado?.segundoNombre,
          attorneyFirstLastName: tramite.apoderado?.primerApellido,
          attorneySecondLastName: tramite.apoderado?.segundoApellido,
          typeOfDocument: tramite.apoderado?.idTipoIdentificacion,
          attorneyNumberOfDocument: tramite.apoderado?.numeroDocumento,
          attorneyProfessionalCard: tramite.apoderado?.tarjetaProfesional,
          attorneyAddress: tramite.apoderado?.direccionPersona,
          attorneyEmail: tramite.apoderado?.email,
        });
      } else {
        if (!this.validarAbogado) {
          this.formFieldsTieneApoderado = this.formFieldsTieneApoderado.map(field => {
            if (field.name === 'attorney') {
              field.value = Constants.VALOR_N;
            }
            return field;
          });
        } else {
          this.formApoderado.get('attorneyNumberOfDocument')?.setErrors({ incorrect: true });
        }
      }
    } else {
      this.getUsuario();
    }
  }

  consultarTramitePorID(id: number) {
    this.proteccionConsumidorService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
        if (resp.anexos) {
          if (this.mostrarArchivos) {
            this.mostrarArchivos = false;
            if (resp.anexos.length > 0) {
              this.archivosPrecargados = resp.anexos;
            }
            setTimeout(() => {
              this.mostrarArchivos = true;
            }, 10)
          }
        }

      });
  }

  getListaDocumentosApoderado() {
    this.formFieldsApoderado = this.formFieldsApoderado.map(
      (field: FormField) => {
        if (field.name === 'typeOfDocument' && field.options?.length) {
          const filteredOptions =
            field.options?.filter(option => option.Id !== 5) || [];
          return { ...field, options: filteredOptions };
        }
        return field;
      }
    );
  }

  private iniciarColumnas() {
    this.columnsNatural = [
      {
        field: 'primerNombre',
        title: this.comunText['primer-nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerApellido',
        title: this.comunText['primer-apellido'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'telefonoPrincipal',
        title: this.comunText['telefono'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.columnsJuridica = [
      {
        field: 'razonSocial',
        title: this.comunText['razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'telefonoPrincipal',
        title: this.comunText['telefono'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: '2',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  getUsuario() {
    this.getDataUser(this.dataUsuario.idUsuario!);
    this.configurarCuentaService
      .getDataPersonal(this.dataUsuario.idUsuario!)
      .subscribe((response: any) => {
        const user_type = JSON.parse(
          sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
        if (user_type.Nombre == 'Abogado') {
          this.getDataUsuario(this.dataUsuario.idPersona!)

        } else {
          this.formTipoPersona.patchValue({
            tipoPersona: `${response.data.Id_Tipo_Persona}`,
          });

          this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
            if (field.name === 'tipoPersona') {
              field.value = `${response.data.Id_Tipo_Persona}`;
            }
            return field;
          });
          this.dataUsuario = this.textTransformService.transformarAMayusculas(
            this.dataUsuario
          );
          if (response.data.Id_Tipo_Persona === 1) {
            const personaNatural: FormPersonaNaturalDto = {
              firstName: this.dataUsuario.primerNombre,
              secondName: this.dataUsuario.segundoNombre,
              firstLastName: this.dataUsuario.primerApellido,
              secondLastName: this.dataUsuario.segundoApellido,
              typeOfDocument: response.data.Id_Tipo_Identificacion,
              numberOfDocument: this.dataUsuario.identificacion,
              email: this.dataUsuario.correoElectronico,
              phone: response.data.Telefono_Principal,
              country: this.dataUsuario.pais == Constants.ID_COLOMBIA ? Constants.ID_COLOMBIA : undefined,
              departament: this.dataUsuario.pais == Constants.ID_COLOMBIA ? this.dataUsuario.departamento : undefined,
              municipality: this.dataUsuario.pais == Constants.ID_COLOMBIA ? +this.dataUsuario.municipio : undefined,
              otroDepartamentoDemandante: this.dataUsuario.otroDepartamento,
              otroMunicipioDemandante: this.dataUsuario.otroMunicipio
            };

            let selectedAddress = response.data.Direccion_Persona.find(
              (address: DireccionPersonaResponseDto) =>
                address.Es_Primaria === true
            );
            if (selectedAddress == undefined) {
              if (response.data.Direccion_Persona) {
                selectedAddress = response.data.Direccion_Persona[0].Direccion_Notificacion
              }
            }

            setTimeout(() => {
              this.formFieldsDemandanteNatural =
                this.formFieldsDemandanteNatural.map(field => {
                  if (
                    personaNatural[field.name as keyof typeof personaNatural] !==
                    undefined
                  ) {
                    field.value =
                      personaNatural[field.name as keyof typeof personaNatural];
                  }

                  if (field.name === 'address') {
                    field.options = response.data.Direccion_Persona.map(
                      (address: DireccionPersonaResponseDto) => ({
                        Id: address.Direccion_Notificacion,
                        Nombre: address.Direccion_Notificacion,
                      })
                    );
                    if (selectedAddress.Direccion_Notificacion) {
                      field.value = selectedAddress.Direccion_Notificacion;
                    } else {
                      field.value = selectedAddress;
                    }

                  }


                  return field;
                });
            }, 500);

            this.formDemandante.patchValue({
              firstName: this.dataUsuario.primerNombre,
              secondName: this.dataUsuario.segundoNombre,
              firstLastName: this.dataUsuario.primerApellido,
              secondLastName: this.dataUsuario.segundoApellido,
              typeOfDocument: response.data.Id_Tipo_Identificacion,
              numberOfDocument: this.dataUsuario.identificacion,
              email: this.dataUsuario.correoElectronico,
              address: [selectedAddress?.Direccion_Notificacion],
              phone: response.data.Telefono_Principal,
              municipality: [
                this.dataUsuario.pais == Constants.ID_COLOMBIA ? this.dataUsuario.municipio : ''],
            });
          } else {
            const personaJuridica: FormPersonaJuridicaDto = {
              typeOfDocument: response.data.Id_Tipo_Identificacion,
              razonSocial: this.dataUsuario.razonSocial,
              numberOfDocument: this.dataUsuario.identificacion,
              email: this.dataUsuario.correoElectronico,
              country: this.dataUsuario.pais == Constants.ID_COLOMBIA ? Constants.ID_COLOMBIA : undefined,
              departament: this.dataUsuario.departamento,
              municipality: this.dataUsuario.pais == Constants.ID_COLOMBIA ? +this.dataUsuario.municipio : undefined,
            };
            let selectedAddress = response.data.Direccion_Persona.find(
              (address: DireccionPersonaResponseDto) =>
                address.Es_Primaria === true
            );
            if (selectedAddress == undefined) {
              if (response.data.Direccion_Persona) {
                selectedAddress = response.data.Direccion_Persona[0].Direccion_Notificacion
              }
            }

            setTimeout(() => {
              this.formFieldsDemandanteJuridic =
                this.formFieldsDemandanteJuridic.map(field => {
                  if (
                    personaJuridica[
                    field.name as keyof typeof personaJuridica
                    ] !== undefined
                  ) {
                    field.value =
                      personaJuridica[field.name as keyof typeof personaJuridica];
                  }
                  if (field.name === 'address') {
                    field.options = response.data.Direccion_Persona.map(
                      (address: DireccionPersonaResponseDto) => ({
                        Id: address.Direccion_Notificacion,
                        Nombre: address.Direccion_Notificacion,
                      })
                    );
                    if (selectedAddress.Direccion_Notificacion) {
                      field.value = selectedAddress.Direccion_Notificacion;
                    } else {
                      field.value = selectedAddress;
                    }
                  }
                  return field;
                });
            }, 500);
          }
        }

      });
  }

  getDataUser(idUsuario: number) {
    this._cuentaService
      .getDataPersonal(idUsuario)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }
      });
  }

  getDataUsuario(idPersona: number) {
    let tarjeta: number = 0;
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        if (response.datoAdicionalAbogado) {
          tarjeta = response.datoAdicionalAbogado.Tarjeta_Profesional;
        }
        setTimeout(() => {
          this.formFieldsTieneApoderado = this.formFieldsTieneApoderado.map(field => {
            switch (field.name) {
              case 'attorney':
                field.value = Constants.VALOR_S;
                break;
            }
            return field;
          });
          this.formFieldsApoderado = this.formFieldsApoderado.map(field => {
            switch (field.name) {
              case 'attorneyFirstName':
                field.value = this.dataUsuario?.primerNombre;
                break;
              case 'attorneyId':
                field.value = this.dataUsuario?.id;
                break;
              case 'attorneySecondName':
                field.value = this.dataUsuario?.segundoNombre ?? '';
                break;
              case 'attorneyFirstLastName':
                field.value = this.dataUsuario?.primerApellido;
                break;
              case 'attorneySecondLastName':
                field.value = this.dataUsuario?.segundoApellido ?? '';
                break;
              case 'typeOfDocument':
                let typeOfDocument = 0;
                switch (this.dataUsuario?.tipoDocumento) {
                  case 'CC':
                    typeOfDocument = 1;
                    break;
                  case 'CE':
                    typeOfDocument = 2;
                    break;
                  case 'Pasaporte':
                    typeOfDocument = 4;
                    break;
                }
                field.value = typeOfDocument;
                break;
              case 'attorneyNumberOfDocument':
                field.value = this.dataUsuario?.identificacion;
                break;
              case 'attorneyProfessionalCard':
                field.value = tarjeta;
                break;
              case 'attorneyAddress':
                field.value = this.dataUsuario?.direccion?.find(
                  (elemento: {
                    Direccion_Notificacion?: string;
                    Es_Primaria?: boolean;
                    Id?: number
                  }) => elemento.Es_Primaria
                )?.Direccion_Notificacion ??
                  this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
                break;
              case 'attorneyEmail':
                field.value = this.dataUsuario?.correoElectronico;
                break;
              default:
                break;
            }
            return field;
          });
        }, 800);
      })
  }

  validarFormularioTipoPersona(formGroup: FormGroup) {
    if (formGroup?.valid) {
      this.formTipoPersona = formGroup;
    }
  }

  validarFormularioTieneApoderado(formGroup: FormGroup) {
    this.formTieneApoderado = formGroup;
    if (this.formTieneApoderado) {
      this.mostrarArchivos = this.formTieneApoderado.get('attorney')?.value === Constants.VALOR_S;
    }
    if (formGroup?.valid) {
      this.formTieneApoderado = formGroup;
    }
  }

  validarFormularioDemandante(formGroup: FormGroup) {
    //if (formGroup.valid) {
    this.formDemandante = formGroup;
    //}

    this.tipoDocumento = formGroup?.get('typeOfDocument')?.value;

    const tipo = formGroup?.value['typeOfDocument'];
    const identificacion = formGroup?.value['numberOfDocument'];

    // Si los valores han cambiado, proceder
    const tipoHaCambiado = tipo !== this.prevTipo;
    const identificacionHaCambiado = identificacion !== this.prevIdentificacion;

    if (
      tipo &&
      identificacion &&
      (tipoHaCambiado || identificacionHaCambiado)
    ) {
      this.prevTipo = tipo;
      this.prevIdentificacion = identificacion;
    }

    this.demandanteEmit.emit({
      formTipoPersonaDemandante: this.formTipoPersona,
      formDemandante: this.formDemandante,
    });
  }

  setDatosUsuario(data: any) {
    data = this.textTransformService.transformarAMayusculas(data);
    if (data.Id_Tipo_Persona === 1) {
      const personaNatural: FormPersonaNaturalDto = {
        firstName: data.Persona_Natural?.[0].Primer_nombre,
        secondName: data.Persona_Natural?.[0].Segundo_nombre,
        firstLastName: data.Persona_Natural?.[0].Primer_apellido,
        secondLastName: data.Persona_Natural?.[0].Segundo_apellido,
        typeOfDocument: data.Id_Tipo_Identificacion,
        numberOfDocument: data.Identificacion,
        email: data.Correo_electronico,
        address: data.Direccion_Persona?.[0].Direccion_Notificacion,
        country: data.Municipio
          ? data.Municipio.Departamento.Pais.Id
          : undefined,
        phone: data.Telefono_Principal,
        departament: data.Municipio
          ? data.Municipio.Departamento.Id
          : undefined,
        municipality: data.Municipio ? data.Municipio.Id : undefined,
      };

      this.formDemandante.patchValue({
        firstName: data.Persona_Natural?.[0].Primer_nombre,
        secondName: data.Persona_Natural?.[0].Segundo_nombre,
        firstLastName: data.Persona_Natural?.[0].Primer_apellido,
        secondLastName: data.Persona_Natural?.[0].Segundo_apellido,
        typeOfDocument: data.Id_Tipo_Identificacion,
        numberOfDocument: data.Identificacion,
        email: data.Correo_electronico,
        address: data.Direccion_Persona?.[0].Direccion_Notificacion,
        phone: data.Telefono_Principal,
        municipality: data.Municipio ? data.Municipio.Id : undefined,
      });

      this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(
        field => {
          if (
            personaNatural[field.name as keyof typeof personaNatural] !==
            undefined
          ) {
            field.value =
              personaNatural[field.name as keyof typeof personaNatural];
          }

          return field;
        }
      );
    } else {
      const personaJuridica: FormPersonaJuridicaDto = {
        numberOfDocument: data.Identificacion,
        typeOfDocument: data.Id_Tipo_Identificacion,
        address: data.Direccion_Persona?.[0].Direccion_Notificacion,
        phone: data.Telefono_Principal,
        email: data.Correo_electronico,
        razonSocial:
          data.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona?.[0]
            .Razon_Social,
        country: data.Municipio
          ? data.Municipio.Departamento.Pais.Id
          : undefined,
        departament: data.Municipio
          ? data.Municipio.Departamento.Id
          : undefined,
        municipality: data.Municipio ? data.Municipio.Id : undefined,
      };

      this.formFieldsDemandanteJuridic = this.formFieldsDemandanteJuridic.map(
        field => {
          if (
            personaJuridica[field.name as keyof typeof personaJuridica] !==
            undefined
          ) {
            field.value =
              personaJuridica[field.name as keyof typeof personaJuridica];
          }

          return field;
        }
      );
    }

    this.mostrarFormulario = true;
  }

  validarFormularioApoderado(formGroup: FormGroup) {
    this.formApoderado = formGroup;
    this.apoderadoEmit.emit({
      formApoderado: this.formApoderado,
    });
  }

  validarSiguiente(): boolean {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (this.formTieneApoderado != undefined) {
      if (this.formTieneApoderado.get('attorney')?.value == Constants.VALOR_N) {
        return true;
      } else {
        let valid: boolean = false;
        if (paso > 1) {
          if (this.formApoderado.valid) {
            valid = true;
          }
        }
        if (paso <= 1) {
          valid = this.validarCamposAbogado(this.formApoderado.value)
        }
        return valid;
      }
    } else {
      return false;
    }
  }

  validarpestania(): { valido: boolean, error?: string } {
    const enabledApoderado = this.validarSiguiente();

    if (!enabledApoderado) {
      return { valido: false, error: Constants.FORM_INVALID };
    }

    let enabledDemandante = false;
    if (this.demandantes.length > 0) {
      const indiceConError = this.demandantes.findIndex(
        d => !this.validarCamposDemandante(d)
      );

      if (indiceConError !== -1) {
        this.mensajeErrorDemandante = this.comunText['valide-datos'];
        enabledDemandante = false;
        return { valido: false, error: Constants.FORM_INVALID };
      } else {
        enabledDemandante = true;
        this.mensajeErrorDemandante = '';
      }
    } else {
      enabledDemandante = false;
      return { valido: false, error: Constants.FORM_INVALID };
    }

    let enabledPoderJudicial = this.getArchivosCargados();

    // Si NO tiene apoderado → no validar anexos judiciales
    if (this.formTieneApoderado.get('attorney')?.value == Constants.VALOR_N) {
      enabledPoderJudicial = true;
    }

    if (!enabledPoderJudicial) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }

    return { valido: true };
  }

  validarCamposDemandante(demandante: PersonaDto): boolean {
    const esNatural = demandante.idTipoPersona === Constants.TIPO_PERSONA.NATURAL;
    // Validaciones comunes
    if (!demandante.idTipoIdentificacion) {
      return false;
    }
    if (!demandante.identificacion) {
      return false;
    }

    const patternIdentificacion = this.getPatternIdentificacion(demandante.idTipoIdentificacion);
    if (!patternIdentificacion.test(demandante.identificacion)) {
      return false;
    }

    if (!demandante.direccionPersona?.[0]?.direccionNotificacion) {
      return false;
    }
    if (!demandante.telefonoPrincipal) {
      return false;
    }
    if (
      !demandante.correoElectronico ||
      !(new RegExp(Constants.REGEX_CORREO_ELECTRONICO)).test(demandante.correoElectronico)
    ) {
      return false;
    }

    // Validaciones específicas
    if (esNatural) {
      if (!demandante.primerNombre ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandante.primerNombre)
      ) {
        return false;
      }
      if (demandante.segundoNombre &&
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandante.segundoNombre)
      ) {
        return false;
      }
      if (!demandante.primerApellido ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandante.primerApellido)) {
        return false;
      }
      if (demandante.segundoApellido &&
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandante.segundoApellido)
      ) {
        return false;
      }
      if (!demandante.municipio?.idPais) {
        return false;
      }
      if (!demandante.municipio?.idDepartamento) {
        return false;
      }
      if (!demandante.municipio?.id) {
        return false;
      }
    } else {
      if (!demandante.razonSocial ||
        !(new RegExp(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL)).test(demandante.razonSocial)) {
        return false;
      }

      const rl = demandante.datosRepresentanteLegal;
      if (!rl) {
        return false;
      }
      if (!rl.primerNombre ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(rl.primerNombre)) {
        return false;
      }
      if (rl.segundoNombre &&
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(rl.segundoNombre)) {
        return false;
      }
      if (!rl.primerApellido ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(rl.primerApellido)) {
        return false;
      }
      if (rl.segundoApellido &&
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(rl.segundoApellido)
      ) {
        return false;
      }
    }
    return true;
  }


  validarCamposAbogado(abogado: any): boolean {
    // Validaciones comunes
    if (!abogado.typeOfDocument) {
      return false;
    }
    if (!abogado.attorneyNumberOfDocument) {
      return false;
    }

    const patternIdentificacion = this.getPatternIdentificacion(abogado.typeOfDocument);
    if (!patternIdentificacion.test(abogado.attorneyNumberOfDocument)) {
      return false;
    }
    if (!abogado.attorneyProfessionalCard) {
      return false;
    }
    if (!abogado.attorneyAddress) {
      return false;
    }
    if (!abogado.attorneyEmail ||
      !(new RegExp(Constants.REGEX_CORREO_ELECTRONICO)).test(abogado.attorneyEmail)
    ) {
      return false;
    }
    if (!abogado.attorneyFirstName ||
      !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(abogado.attorneyFirstName)
    ) {
      return false;
    }
    if (abogado.attorneySecondName &&
      !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(abogado.attorneySecondName)
    ) {
      return false;
    }
    if (!abogado.attorneyFirstLastName ||
      !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(abogado.attorneyFirstLastName)
    ) {
      return false;
    }
    if (abogado.attorneySecondLastName &&
      !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(abogado.attorneySecondLastName)
    ) {
      return false;
    }
    return true;
  }


  getPatternIdentificacion(tipoDocumentoId: number): RegExp {
    switch (tipoDocumentoId) {
      case 1:
      case 2:
        return /^\d{4,12}$/;
      case 4:
        return /^[a-zA-Z0-9]{4,8}$/;
      case 3:
        return /^\d+$/;
      case 5:
        return /^\d{4,9}$/;
      default:
        return /.*/;
    }
  }

  getArchivosCargados() {
    let valid: boolean = false;
    if (this.tramiteSic?.anexos) {
      this.tramiteSic?.anexos.forEach(element => {
        if (element.tipoAnexoTipoTramite.orden == 1) {
          valid = true;
          if (this.archivosCargadosPasoUno.length > 0) {
            this.archivosCargadosPasoUno.forEach(element => {
              if (element.files.length > 0) {
                valid = true;
              } else {
                valid = false;
              }
            })
          }
        }
      });
    } if (this.archivosCargadosPasoUno.length > 0) {
      this.archivosCargadosPasoUno.forEach(element => {
        if (element.files.length > 0) {
          valid = true;
        }
      })
    } else {
      valid = false;
    }
    return valid;
  }

  validarGuardarSinEnviar() {
    if (
      this.demandantes.length > 0
    ) {
      return false;
    } else if (
      this.demandantes.length > 0 &&
      this.formTieneApoderado?.get('attorney')?.value === Constants.VALOR_N
    ) {
      return false;
    } else if (
      this.demandantes.length > 0 &&
      this.formTieneApoderado?.get('attorney')?.value === Constants.VALOR_S
    ) {
      return this.formApoderado?.invalid;
    } else {
      return true;
    }
  }

  onChangeValidarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    const formGroup = $event.form;
    const idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    const identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoDemandanteN = this.formFieldsDemandanteNatural.find(
      field => field.name == 'numberOfDocument'
    );
    const numeroDocumentoDemandanteJ = this.formFieldsDemandanteJuridic.find(
      field => field.name == 'numberOfDocument'
    );
    const identificacionApoderado: number = +formGroup?.get(
      'attorneyNumberOfDocument'
    )?.value;
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoDemandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandanteN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandanteN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandanteN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandanteN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandanteJ != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandanteJ.errorMessages!['maxlength'] =
              'El número de identificación debe tener máximo 9 números.';
            numeroDocumentoDemandanteJ.errorMessages!['pattern'] =
              'El número de identificación solo acepta números, No se permiten espacios ni caracteres especiales.';
          }
        }
        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    const numeroDocumentoApoderado = this.formFieldsApoderado.find(
      field => field.name == 'attorneyNumberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'attorneyNumberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacionApoderado !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('attorneyNumberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('attorneyNumberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8)
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          formGroup
            .get('attorneyNumberOfDocument')
            ?.setValidators([
              Validators.required,
              Validators.maxLength(9),
              Validators.pattern(/^\d+$/),
            ]);
        }

        formGroup?.get('attorneyNumberOfDocument')?.updateValueAndValidity();
      }
    }

    if ($event.controlName === 'country' || formGroup?.get('country')?.value) {
      const idPais = formGroup?.get('country')?.value;
      const idColombia = this.paises.find(
        item => item.Codigo === Constants.CODIGO_COLOMBIA
      )?.Id;
      if (idPais === idColombia) {
        formGroup?.controls['otroDepartamentoDemandante']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandante']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandante')?.reset();
        formGroup?.get('otroMunicipioDemandante')?.reset();
        formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
      } else if (idPais !== null) {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandante.push(
            formGroup?.controls['country'].value
          );
          if (this.auxIdCountryDemandante.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandante[
              this.auxIdCountryDemandante.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandante'].setValue('');
          formGroup?.controls['otroMunicipioDemandante'].setValue('');
        }
        formGroup?.controls['otroDepartamentoDemandante']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandante']?.addValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
      }
    }
  }

  validarFormularioMedios(formGroup: FormGroup) {
    this.formMediosTec = formGroup;
  }

  validAddDemandante(): boolean {
    if (this.formDemandante.valid && this.formMediosTec.valid) {
      return false;
    } else {
      return true;
    }
  }

  cancelarEditarDemandante() {
    this.indexEditarDemandante = undefined;
    this.formDemandante.reset();
    this.formTipoPersona.reset();
    this.formMediosTec.reset();

    this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
      field.value = undefined;
      field.disabled = false;
      return field;
    });

    this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(
      field => {
        if (field.name === 'country') {
          field.value = Constants.ID_COLOMBIA;
        } else {
          field.value = undefined;
        }
        return field;
      }
    );

    this.formFieldsDemandanteJuridic = this.formFieldsDemandanteJuridic.map(
      field => {
        field.value = undefined;
        return field;
      }
    );

    this.formFieldsMedios = this.formFieldsMedios.map(field => {
      field.value = undefined;
      field.disabled = false;
      return field;
    });
  }

  agregarDemandante(index: number | undefined = undefined) {
    const representanteLegal: PersonaDto = {
      idTipoPersona:
        this.formTipoPersona.value['tipoPersona'] === '2' ? undefined : 1,
      primerNombre: this.formDemandante.value['representativeFirstName'] ?? '',
      segundoNombre: this.formDemandante.value['representativeSecondName'] ?? '',
      primerApellido: this.formDemandante.value['representativFirstLastName'] ?? '',
      segundoApellido:
        this.formDemandante.value['representativeSecondLastName'] ?? '',
    };
    const medios = this.formMediosTec.get('medios')?.value;
    const demandante: PersonaDto = {
      idTipoPersona: Number(this.formTipoPersona.value['tipoPersona']) ?? undefined,
      idTipoIdentificacion: Number(this.formDemandante.value['typeOfDocument']) ?? undefined,
      identificacion: this.formDemandante.value['numberOfDocument'] ?? undefined,
      razonSocial: this.formDemandante.value['razonSocial'] ?? '',
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandante.value['address'] ?? '',
        },
      ],
      telefonoPrincipal: this.formDemandante.value['phone'] ?? '',
      municipio: {
        id: Number(this.formDemandante.value['municipality']) ?? undefined,
        idDepartamento: Number(this.formDemandante.value['departament']) ?? undefined,
        idPais: Constants.ID_COLOMBIA,
      },
      correoElectronico: this.formDemandante.value['email'] ?? '',
      datosRepresentanteLegal:
        this.formTipoPersona.value['tipoPersona'] == 1
          ? null
          : representanteLegal,
      primerNombre: this.formDemandante.value['firstName'] ?? '',
      segundoNombre: this.formDemandante.value['secondName'] ?? '',
      primerApellido: this.formDemandante.value['firstLastName'] ?? '',
      segundoApellido: this.formDemandante.value['secondLastName'] ?? '',
      departamentoExtranjero:
        this.formDemandante.value['otroDepartamentoDemandante'] ?? '',
      ciudadExtranjero: this.formDemandante.value['otroMunicipioDemandante'] ?? '',
      tieneAccesoMediosTecnologicos: medios === Constants.VALOR_S,
    };

    let existe;
    if (index !== undefined) {
      existe = this.demandantes.some(
        (item, i) =>
          index !== i &&
          item.idTipoIdentificacion === demandante.idTipoIdentificacion &&
          item.identificacion === demandante.identificacion
      );
    } else {
      existe = this.demandantes.some(
        item =>
          item.idTipoIdentificacion === demandante.idTipoIdentificacion &&
          item.identificacion === demandante.identificacion
      );
    }
    this.demandados = JSON.parse(sessionStorage.getItem('demandados')!);
    this.apoderado = JSON.parse(sessionStorage.getItem('apoderado')!);
    const isEmptyDemandado: boolean = this.searchInDemandados(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );
    const isEmptyApoderado: boolean = this.searchInApoderado(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );
    if (isEmptyDemandado && isEmptyApoderado) {
      if (existe) {
        this.existePersona = existe;
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['demandante-ya-agregado']
        );
      } else {
        if (index !== undefined) {
          this.demandantes[index] = demandante;
        } else {
          this.demandantes.push(demandante);
        }

        this.dataTableNatural = this.demandantes.filter(
          item => item.idTipoPersona === 1
        );
        this.dataTableJuridic = this.demandantes.filter(
          item => item.idTipoPersona === 2
        );

        this.iniciarColumnas();
        this.reiniciarFormularios();
        this.alertaModalService.exito(
          this.alertaText['agregado'],
          this.alertaText['demandante-agregado']
        );
        sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));
        this.indexEditarDemandante = undefined;
        setTimeout(() => {
          this.buildFormsDemandante();
        }, 10)
      }
    }
    this.auxIdCountryDemandante = [];
  }

  onClickSiguiente(event: Event) {
    const result = this.validarpestania();

    if (!result.valido) {

      switch (result.error) {

        case Constants.FORM_INVALID:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          break;

        case Constants.ANEXOS_INCOMPLETOS:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          break;

        default:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          break;
      }

      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });

      return;
    }

    // Todo está correcto
    this.pasarADemandado(event, false);
  }

  pasarADemandado(e: Event, guardarSinEnviar: boolean) {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso && !guardarSinEnviar) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(2));
    }
    let isEmptyDemandado = true;
    let isEmptyDemandante = true;
    //this.demandados = JSON.parse(sessionStorage.getItem('demandados')!);
    //this.demandantes = JSON.parse(sessionStorage.getItem('demandantes')!);

    let apoderado: PersonaDto = {};

    if (this.formTieneApoderado.value['attorney'] == Constants.VALOR_S) {
      apoderado = {
        idTipoPersona:
          this.formTieneApoderado.value['attorney'] == Constants.VALOR_S ? 1 : undefined,
        id: this.formApoderado.value['attorneyId'] ?? undefined,
        primerNombre: this.formApoderado.value['attorneyFirstName'] ?? '',
        segundoNombre: this.formApoderado.value['attorneySecondName'] ?? '',
        primerApellido: this.formApoderado.value['attorneyFirstLastName'] ?? '',
        segundoApellido: this.formApoderado.value['attorneySecondLastName'] ?? '',
        idTipoIdentificacion: this.formApoderado.value['typeOfDocument'] ?? undefined,
        identificacion: this.formApoderado.value['attorneyNumberOfDocument'] ?? '',
        tarjetaProfesional: this.formApoderado.value['attorneyProfessionalCard'],
        direccionPersona: [
          {
            direccionNotificacion: this.formApoderado.value['attorneyAddress'] ?? '',
          },
        ],
        correoElectronico: this.formApoderado.value['attorneyEmail'] ?? '',
        esApoderado:
          this.formTieneApoderado.value['attorney'] == Constants.VALOR_S ? true : undefined,
      };
      if (this.demandados) {
        isEmptyDemandado = this.searchInDemandados(
          +this.formApoderado.value['typeOfDocument'],
          +apoderado.identificacion!
        );
      }
      if (this.demandantes) {
        isEmptyDemandante = this.searchInDemandantes(
          +this.formApoderado.value['typeOfDocument'],
          +apoderado.identificacion!
        );
      }
    }

    const medios = this.formMediosTec.get('medios')?.value?.[0];
    if (this.formTipoPersona.valid) {
      if (!guardarSinEnviar) {
        if (this.formDemandante.valid) {
          this.agregarDemandante(this.indexEditarDemandante)
        }
      } else {
        this.agregarDemandante(this.indexEditarDemandante)
      }
    }
    const tramite: TramiteSicProteccionConsumidorDto = {
      id: this.tramiteSic ? this.tramiteSic.id : null,
      enviar: false,
      demandante: this.demandantes,
      //tieneAccesoMediosTecnologicos: medios === Constants.VALOR_S,
      usuario: {
        id: this.dataUsuario.idUsuario,
      },
    };
    if (isEmptyDemandado && isEmptyDemandante) {
      tramite.apoderado = apoderado;
      sessionStorage.setItem('apoderado', JSON.stringify(apoderado));
    } else {
      // Existe en demandados o demandantes
      this.validarAbogado = true;
      this.formApoderado.get('attorneyNumberOfDocument')?.setValue('');
      apoderado.identificacion = '';
    }
    if (!guardarSinEnviar) {
      this.continuar.emit({
        tramite: tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    }
  }

  renombarArchivo(archivo: File, nuevoNombre: string): File {
    return new File([archivo], nuevoNombre, {
      type: archivo.type,
      lastModified: archivo.lastModified,
    });
  }

  habilitarBoton(): boolean {
    const apoderado = this.formTieneApoderado.get('attorney')?.value?.[0];

    if (this.demandantes.length === 0) {
      return false;
    }

    if (apoderado !== undefined) {
      if (apoderado === Constants.VALOR_S) {
        return this.formApoderado.valid || this.formMediosTec.valid;
      }

      if (apoderado === Constants.VALOR_N) {
        return this.formMediosTec.valid;
      }
    } else {
      return false;
    }

    return true;
  }

  setearDatosDemandante(persona: PersonaDto) {
    this.formTipoPersona.patchValue({
      tipoPersona: `${persona.idTipoPersona ?? 1}`,
    });
    this.formMediosTec.patchValue({
      medios: persona.tieneAccesoMediosTecnologicos ? Constants.VALOR_S : Constants.VALOR_N,
    });

    this.formFieldsMedios = this.formFieldsMedios.map(field => {
      if (field.name === Constants.MEDIOS_TEC) {
        field.value = persona.tieneAccesoMediosTecnologicos ? Constants.VALOR_S : Constants.VALOR_N;
      }
      return field;
    });
    this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
      switch (field.name) {
        case 'tipoPersona':
          field.value = persona.idTipoPersona ?? 1;
          break;
      }
      return field;
    });
    if (persona.idTipoPersona === +Constants.TYPE_OF_PERSON_NATURAL) {
      setTimeout(() => {
        this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'firstName':
              field.value = persona.primerNombre;
              break;
            case 'secondName':
              field.value = persona.segundoNombre;
              break;
            case 'firstLastName':
              field.value = persona.primerApellido;
              break;
            case 'secondLastName':
              field.value = persona.segundoApellido;
              break;
            case 'address':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'phone':
              field.value = persona.telefonoPrincipal;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              field.disabled = true;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandante':
              field.value = persona.otroDepartamento;
              break;
            case 'otroMunicipioDemandante':
              field.value = persona.otroMunicipio;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
          }
          return field;
        });
      }, 800);
    } else {
      setTimeout(() => {
        this.formFieldsDemandanteJuridic = this.formFieldsDemandanteJuridic.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'razonSocial':
              field.value = persona.razonSocial;
              break;
            case 'address':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'phone':
              field.value = persona.telefonoPrincipal;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              field.disabled = true;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
            case 'representativeFirstName':
              field.value = persona.datosRepresentanteLegal?.primerNombre;
              break;
            case 'representativeSecondName':
              field.value = persona.datosRepresentanteLegal?.segundoNombre;
              break;
            case 'representativFirstLastName':
              field.value = persona.datosRepresentanteLegal?.primerApellido;
              break;
            case 'representativeSecondLastName':
              field.value = persona.datosRepresentanteLegal?.segundoApellido;
              break;
          }
          return field;
        });
      }, 800)
    }
  }

  accionesDemandante(event: any) {
    const persona = event.item as PersonaDto;
    if (event.idAccion == '2') { // editar
      this.indexEditarDemandante = this.demandantes.findIndex(
        (d) =>
          d.idTipoIdentificacion === persona.idTipoIdentificacion &&
          d.identificacion === persona.identificacion
      );
      this.setearDatosDemandante(persona);
    } else if (event.idAccion == '1') { // eliminar
      this.alertaModalService.confirmacion(
        this.alertaText['sic-procon-alertas']['eliminar-registro'],
        '',
        () => {
          this.demandantes = this.demandantes.filter(item => item !== persona);

          this.dataTableNatural = this.demandantes.filter(
            item => item.idTipoPersona === 1
          );
          this.dataTableJuridic = this.demandantes.filter(
            item => item.idTipoPersona === 2
          );
          sessionStorage.setItem('demandantes', JSON.stringify(this.demandantes));
          this.iniciarColumnas();
        },
        () => { }
      );
    }
  }

  reiniciarFormularios() {
    this.demandados = JSON.parse(sessionStorage.getItem('demandados')!);
    if (!this.existePersona) {
      if (this.demandados) {
        this.consultarPersonas(this.demandados)
      } else {
        this.mostrarFormulario = false;
        setTimeout(() => {
          this.formDemandante.reset();
          this.formMediosTec.reset();
          this.formTipoPersona.reset();
          this.mostrarFormulario = true;

          this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
            field.value = undefined;
            field.disabled = false;
            return field;
          });

          this.formFieldsDemandanteNatural = this.formFieldsDemandanteNatural.map(
            field => {
              if (field.name === 'country') {
                field.value = Constants.ID_COLOMBIA;
              } else {
                field.value = undefined;
              }
              return field;
            }
          );

          this.formFieldsDemandanteJuridic = this.formFieldsDemandanteJuridic.map(
            field => {
              field.value = undefined;
              return field;
            }
          );

          this.formFieldsMedios = this.formFieldsMedios.map(field => {
            field.value = undefined;
            field.disabled = false;
            return field;
          });
        }, 0);
      }

    } else {
      this.formDemandante.get('numberOfDocument')?.setErrors({ incorrect: true });
    }

  }

  searchInApoderado(idTipoDocumento: number, identificacion: number): boolean {
    if (this.apoderado) {
      if (
        this.apoderado.idTipoIdentificacion === idTipoDocumento &&
        +this.apoderado.identificacion! === identificacion
      ) {
        this.alertaModalService.advertencia(
          this.alertaText['tipo-numero-documento-existe-apoderado']
        );
        return false;
      }
    }
    return true;
  }

  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    if (this.demandados) {
      this.demandados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandado']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number
  ): boolean {
    let isEmpty = true;
    if (this.demandantes) {
      this.demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandante']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  cargarPoderJudicial(event: any) {
    if (event.length === 0) {
      return;
    }
    const newFiles: File[] = event;
    newFiles.forEach(file => {
      this.anexoPoderJudicial = {
        Archivos: [file],
        tipoAnexo: "" + this.tipoAnexoPoderJudicial?.id,
      };
    });
  }

  borrarPoderJudicial() {
    this.anexoPoderJudicial = null;
  }

  archivosCargados(event: File[]) {
    let archivos = event;
    const totalBytes = archivos.reduce(
      (total, archivo) => total + archivo.size,
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  protected readonly JSON = JSON;
  protected readonly Constants = Constants;
  // Función que almacena los archivos requeridos por cada uno de los pasos
  validarArchivosRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    this.idsFilesPasoUno = this.buscarRequeridos(evento.archivos);
  }
  // Función que retorna los archivos con la propiedad de requerido = true
  buscarRequeridos(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    // Se validan archivos con el mismo ID, se deja el último.
    // Debido a que, corresponde al momento en que el paso 3 carga el formulario y los anexos
    const data = archivos;
    const unicos = Array.from(
      new Map(data.map(obj => [obj.item.id, obj])).values()
    );
    this.archivosCargadosPasoUno = unicos;
    let total = 0;
    archivos.forEach(element => {
      element.files.forEach(item => {
        total = total + item.size;
      })
    })
    if (this.archivosCargadosPasoUno.length > 0) {
      this.archivosCargadosPasoUno.forEach(element => {
        if (element.files.length > 0) {
          this.pesoTotalArchivosMB = (total / (1024 * 1024)).toFixed(2);
          sessionStorage.setItem(Constants.ARCHIVOS_SIC_PROCON_PASO_UNO, 'true');
        } else {
          this.pesoTotalArchivosMB = '0.00';
        }
      })
    }
  }

  subirArchivo(subio: any) {
    this.guardarArchivos = false;
  }

  consultarPersonas(demandado: PersonaDto[]) {
    if (this.formDemandante) {
      let tipoDoc = this.formDemandante.get('typeOfDocument')?.value;
      let doc = this.formDemandante.get('numberOfDocument')?.value;
      let existe = this.demandantes.some(
        item =>
          item.idTipoIdentificacion == tipoDoc &&
          item.identificacion == doc
      );
      this.apoderado = JSON.parse(sessionStorage.getItem('apoderado')!);
      const isEmptyDemandado = demandado.some(elemento =>
        elemento.idTipoIdentificacion == tipoDoc &&
        +elemento.identificacion! == doc
      );
      const isEmptyApoderado: boolean = this.searchInApoderado(
        tipoDoc,
        doc
      );

      if (!isEmptyApoderado || isEmptyDemandado || existe) {
        this.existePersona = true;
        this.formDemandante.get('numberOfDocument')?.setErrors({ incorrect: true });
      }
    }
  }
}
